import { render, staticRenderFns } from "./NewProcess.vue?vue&type=template&id=36feb685&"
import script from "./NewProcess.vue?vue&type=script&lang=js&"
export * from "./NewProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewProcess.vue"
export default component.exports